export function getdata() {
	var obj = {
		headDataI: [{
				title: "项目",
				prop: 'title',
				width: "280px",
				custom: true,
			},
			{
				title: "行次",
				prop: 'grade',
				width: "100px",
			},
			{
				title: "本年数",
				prop: "cwbbqykjzd_3_x_1",
				custom: true,
				width: "200px"
			},
			{
				title: '上年数',
				prop: 'cwbbqykjzd_3_x_2',
				width: "200px",
				custom: true,
			},
		],
		tableDataI: [{
				title: "一、实收资本(或股本)：",
				grade: '',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_1_1",
					cellType: "1",
					cellVal: "240040043.08",
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_1_2",
					cellType: "1",
					cellVal: "240040043.08",
				},
			},
			{
				title: "年初余额",
				grade: '1',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_2_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_2_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "本年增加数",
				grade: '2',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_3_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_3_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其中：资本公积转入",
				grade: '3',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_4_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_4_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "盈余公积转入",
				grade: '4',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_5_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_5_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "利润分配转入",
				grade: '5',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_6_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_6_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "新增资本(或股本)",
				grade: '6',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_7_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_7_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "本年减少数",
				grade: '10',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_8_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_8_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "年末余额",
				grade: '15',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_9_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_9_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "二、资本公积",
				grade: '',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				wbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_10_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_10_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "年初余额",
				grade: '16',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_11_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_11_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "本年增加数",
				grade: '17',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_12_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_12_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其中：资本(或股本)溢价",
				grade: '18',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_13_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_13_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "接受捐赠非现金资产准备",
				grade: '19',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_14_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_14_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "接受现金捐赠",
				grade: '20',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_15_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_15_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "股权投资准备",
				grade: '21',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "拨款转入：",
				grade: '22',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "外币资本折算差额",
				grade: '23',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其他资本公积",
				grade: '30',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "本年减少数",
				grade: '40',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其中：转增资本(或股本)",
				grade: '41',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "年末余额",
				grade: '45',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "三、法定和任意盈余公积",
				grade: '',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "年初余额",
				grade: '46',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "本年增加数",
				grade: '47',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其中：从净利润中提取数",
				grade: '48',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其中：法定盈余公积",
				grade: '49',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "任意盈余公积",
				grade: '50',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "储备基金",
				grade: '51',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "企业发展基金",
				grade: '52',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "法定公益金转入数",
				grade: '53',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "本年减少数",
				grade: '54',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其中：弥补亏损",
				grade: '55',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "转增资本(或股本)",
				grade: '56',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "分派现金股利或利润",
				grade: '57',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "分派股票股利",
				grade: '58',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "年末余额",
				grade: '62',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其中：法定盈余公积",
				grade: '63',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "储备基金",
				grade: '64',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "企业发展基金",
				grade: '65',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "四、法定公益金",
				grade: '',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "年初余额",
				grade: '66',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "本年增加数",
				grade: '67',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其中：从净利润中提取数",
				grade: '68',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "本年减少数",
				grade: '70',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其中：集体福利支出",
				grade: '71',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "年末余额",
				grade: '75',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "五、未分配利润：",
				grade: '',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "年初未分配利润",
				grade: '76',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "本年净利润(净亏损以“－”号填列)",
				grade: '77',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "本年利润分配",
				grade: '78',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "年末未分配利润(未弥补亏损以“－”号填列)",
				grade: '80',
				disabledcwbbqykjzd_3_x_1: false,
				disabledcwbbqykjzd_3_x_2: false,
				cwbbqykjzd_3_x_1: {
					cellCode: "cwbbwxz_1_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbqykjzd_3_x_2: {
					cellCode: "cwbbwxz_1_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
			},
		]
	}
	return obj
}
